<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div style="text-align: left;margin:10px;" class="">
        <h5>My Area 
           <b-button class="float-right" @click="handleback" variant="danger" style="margin-bottom:-10px;">
              <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
          </b-button> 
        </h5>
        <hr/>
      </div>
      <div class="panel-body">
        <div>
          <div class="md-2">
           
            <i class="fa fa-trash-o" style="font-size: 36px"></i>
            <b-card
              img-src="https://picsum.photos/400/400/?image=10"
              img-alt="Card image"
              img-left
              class="mb-2"
              style="height: 120px"
            >
              <!-- <b-card
            class='fas fa-map-marker-alt'
            > -->
              <b-card-text class="mycard">
                <table style="line-height: 1">
                  <tr>
                    <td width="45%" style="text-align: left">Village Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">kolhapur</td>
                    <td>
                       <b-icon-check-circle style="color:green;font-size:25px;"></b-icon-check-circle>
                    </td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Pin Code</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">416001</td>
                  </tr>
                  <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                  <tr>
                    <td width="45%" style="text-align: left">No Of Farmers</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">50</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </div>
          <div class="md-2">
            <p class="right" style="text-align: right"></p>
            <i class="fa fa-trash-o" style="font-size: 36px"></i>
            <b-card
              img-src="https://picsum.photos/400/400/?image=60"
              img-alt="Card image"
              img-left
              class="mb-2"
              style="height: 120px"
            >
              <!-- <b-card
            class='fas fa-map-marker-alt'
            > -->
              <b-card-text class="mycard">
                <table style="line-height: 1">
                  <tr>
                    <td width="45%" style="text-align: left">Village Name</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">kolhapur</td>
                    <td>
                       <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">Set Default</b-dropdown-item>
                    </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td width="45%" style="text-align: left">Pin Code</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">416001</td>
                  </tr>
                  <!-- <tr>
                    <td width="45%" style="text-align:left">Animal Type</td>
                    <td width="1%" style="text-align:left">:</td>
                    <td width="54%" style="text-align:left">**</td>
                  </tr> -->
                  <tr>
                    <td width="45%" style="text-align: left">No Of Farmers</td>
                    <td width="1%" style="text-align: left">:</td>
                    <td width="54%" style="text-align: left">50</td>
                  </tr>
                </table>
              </b-card-text>
            </b-card>
          </div>
          <button
            type="submit"
            style="float: right"
            class="btn btn-sm btn-primary"
          >
            Add New Area
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import * as _ from "lodash";

//import ApplicationFilter from "../components/ApplicationFilter.vue";
//import MarksEntry from "../components/MarksEntry.vue";
//alert(1);
export default {

  methods: {
    handleback(){
            this.$router.go(-1);
        },
  },
  

};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
body {
  line-height: 1;
}
</style>

